import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="mx-auto max-w-[1240px] px-4 pb-4 md:px-8">
      <div className="relative overflow-hidden rounded-lg bg-primary-500 px-6 py-12 md:px-14 md:py-16">
        <div
          className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-accent-400/30"
          aria-hidden="true"
        />
        <div
          className="pointer-events-none absolute -bottom-20 left-10 h-48 w-48 rounded-full bg-primary-700/40"
          aria-hidden="true"
        />

        <div className="relative flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <div className="max-w-2xl">
            <h2 className="font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
              想看谁的生图最能打？
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-100/90 md:text-base">
              把你的关注意向告诉我们，编辑团队会优先整理你感兴趣的红毯场次与同框名场面。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              to="/contact"
              className="flex h-11 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
            >
              <i className="ri-chat-smile-2-line text-lg" aria-hidden="true"></i>
              告诉我们
            </Link>
            <Link
              to="/category/redcarpet"
              className="flex h-11 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/50 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              先看红毯生图
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}